import { render, staticRenderFns } from "./AddSynonymModal.vue?vue&type=template&id=662639d1"
import script from "./AddSynonymModal.vue?vue&type=script&lang=js"
export * from "./AddSynonymModal.vue?vue&type=script&lang=js"
import style0 from "./AddSynonymModal.vue?vue&type=style&index=0&id=662639d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports